import Glide from "@glidejs/glide";

// Store Vimeo players by iframe ID
const vimeoPlayerMap = {};

const initialiseSliders = () => {
    const sliders = document.querySelectorAll(".home-page-banner__glide");
    if (sliders.length === 0) return;

    sliders.forEach((sliderElement) => {
        if (!sliderElement.hasAttribute("data-initialized")) {
            const autoplayAttr = sliderElement.getAttribute("data-autoplay");
            const autoplayValue =
                autoplayAttr && autoplayAttr.toLowerCase() === "true" ? 3000 : false;

            const glide = new Glide(sliderElement, {
                type: "carousel",
                startAt: 0,
                perView: 1,
                autoplay: 3000,
                gap: 0,
            }).mount();

            const currentSlide = sliderElement.querySelector(
                ".home-page-banner__current-slide",
            );
            const totalSlides = sliderElement.querySelector(
                ".home-page-banner__total-slides",
            );
            const toggleButton = sliderElement.querySelector(".glide__toggle");

            const updateSlideInfo = () => {
                currentSlide.textContent = glide.index + 1;
                totalSlides.textContent = glide._c.Html.slides.length;
            };

            updateSlideInfo();
            glide.on(["mount.after", "run"], updateSlideInfo);

            toggleButton.addEventListener("click", () => {
                if (toggleButton.classList.contains("pause")) {
                    glide.pause();
                    toggleButton.classList.remove("pause");
                    toggleButton.classList.add("play");
                } else {
                    glide.play();
                    toggleButton.classList.remove("play");
                    toggleButton.classList.add("pause");
                }
            });

            sliderElement.setAttribute("data-initialized", "true");
        }
    });
};

// Video controls for play/pause functionality (only for local and Vimeo videos)
const setupVideoControls = () => {
    //console.log('Setting up video controls');
    const videoControls = document.querySelectorAll(".home-page-banner__video-controls");
    if (!videoControls.length) {
        //console.log('No video controls found');
        return;
    }

    videoControls.forEach((controlElement) => {
        const toggleButton = controlElement.querySelector(".video-toggle");
        if (!toggleButton) {
            //console.log('No toggle button found');
            return;
        }

        const videoType = controlElement.getAttribute('data-video-type');
        //console.log('Video type:', videoType);
        
        // Skip YouTube videos - we'll just let them autoplay
        if (videoType === "video-youtube") {
            // Hide the controls for YouTube videos
            controlElement.style.display = "none";
            return;
        }
        
        // Find the video element or iframe
        const section = controlElement.closest('.wp-block-block-builder-federalgroup-home-page-banner');
        let videoElement;
        
        if (videoType === "video-local") {
            videoElement = section.querySelector('video.home-page-banner__background-video');
        } else if (videoType === "video-vimeo") {
            videoElement = section.querySelector('iframe#vimeo-iframe');
        }
        
        if (!videoElement) {
            //console.log('No video element found for type:', videoType);
            return;
        }
        
       // console.log('Found video element:', videoElement);

        // Initialize as playing initially (showing pause button)
        toggleButton.classList.add("pause");
        toggleButton.classList.remove("play");

        toggleButton.addEventListener("click", () => {
           // console.log('Control button clicked for', videoType);
            
            if (videoType === "video-local") {
                if (toggleButton.classList.contains("pause")) {
                    // Pause the video
                    videoElement.pause();
                    toggleButton.classList.remove("pause");
                    toggleButton.classList.add("play");
                   // console.log('Local video paused');
                } else {
                    // Play the video
                    videoElement.play();
                    toggleButton.classList.remove("play");
                    toggleButton.classList.add("pause");
                    //console.log('Local video played');
                }
            } else if (videoType === "video-vimeo") {
                handleVimeoToggle();
            }
        });

        // Vimeo specific handling
        let vimeoPlayer = null;
        function handleVimeoToggle() {
            ensureVimeoAPIReady().then(Vimeo => {
                if (!vimeoPlayer) {
                    vimeoPlayer = new Vimeo.Player(videoElement);
                }
                
                if (toggleButton.classList.contains("pause")) {
                    // Pause the video
                    vimeoPlayer.pause().then(() => {
                        toggleButton.classList.remove("pause");
                        toggleButton.classList.add("play");
                        //console.log('Vimeo video paused');
                    }).catch(error => {
                        //console.error("Error pausing Vimeo video:", error);
                    });
                } else {
                    // Play the video
                    vimeoPlayer.play().then(() => {
                        toggleButton.classList.remove("play");
                        toggleButton.classList.add("pause");
                        //console.log('Vimeo video played');
                    }).catch(error => {
                        //console.error("Error playing Vimeo video:", error);
                    });
                }
            });
        }
    });
};

// Vimeo API loading function
function ensureVimeoAPIReady() {
    return new Promise((resolve, reject) => {
        if (window.Vimeo && window.Vimeo.Player) {
            return resolve(window.Vimeo);
        }

        // If we already have a script tag, don't add another one
        if (document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
            // Poll for API ready
            const checkVimeo = setInterval(() => {
                if (window.Vimeo && window.Vimeo.Player) {
                    clearInterval(checkVimeo);
                    resolve(window.Vimeo);
                }
            }, 100);
            return;
        }

        const tag = document.createElement("script");
        tag.src = "https://player.vimeo.com/api/player.js";
        tag.onload = () => resolve(window.Vimeo);
        tag.onerror = reject;

        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
}

const removePosterImage = (videoWrapper) => {
    const poster = videoWrapper.querySelector(".home-page-banner__poster-image");
    if (poster) {
        videoWrapper.classList.add('playing');
    }
};

const handleIframeVideos = async () => {
    const videoWrappers = document.querySelectorAll(
        ".home-page-banner__background-video-wrapper"
    );

    if (!videoWrappers.length) return;

    for (const wrapper of videoWrappers) {
        const videoType = wrapper.dataset.videoType;

        // Handle local videos
        if (videoType === "video-local") {
            const video = wrapper.querySelector('video');
            if (video) {
                video.addEventListener('loadeddata', () => {
                    if (video.readyState >= 2) {
                        removePosterImage(wrapper);
                    }
                });
                
                video.addEventListener('playing', () => {
                    removePosterImage(wrapper);
                });

                // Force HD if available
                if (video.videoHeight >= 1080) {
                    video.style.minHeight = '1080px';
                }
            }
        }

        // Handle Vimeo videos
        if (videoType === "video-vimeo") {
            try {
                const Vimeo = await ensureVimeoAPIReady();
                const iframe = wrapper.querySelector('iframe');
                
                if (iframe) {
                    const player = new Vimeo.Player(iframe);
                    
                    player.ready().then(() => {
                        // Set quality if possible
                        player.setQuality('1080p')
                            .catch(() => player.setQuality('720p'))
                            .catch(() => console.log('Could not set Vimeo quality'));
                    });

                    player.on('play', () => {
                        removePosterImage(wrapper);
                        // Make sure toggle button reflects playing state
                        const section = wrapper.closest('.wp-block-block-builder-federalgroup-home-page-banner');
                        const toggleButton = section.querySelector(".video-toggle");
                        if (toggleButton) {
                            toggleButton.classList.add("pause");
                            toggleButton.classList.remove("play");
                        }
                    });
                    
                    player.on('pause', () => {
                        // Make sure toggle button reflects paused state
                        const section = wrapper.closest('.wp-block-block-builder-federalgroup-home-page-banner');
                        const toggleButton = section.querySelector(".video-toggle");
                        if (toggleButton) {
                            toggleButton.classList.remove("pause");
                            toggleButton.classList.add("play");
                        }
                    });

                    player.on('loaded', () => {
                        player.setLoop(true);
                    });
                }
            } catch (error) {
                //console.error('Error initializing Vimeo player:', error);
            }
        }
    }
};

// Initialize everything when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initialiseSliders();
        handleIframeVideos();
        setupVideoControls();
    });
} else {
    initialiseSliders();
    handleIframeVideos();
    setupVideoControls();
}